<template>
  <div class="sidebar">
    <div
      class="sidebar-wrapper"
      style="
        background: #1a1919;
        color: #efefef !important;
        display: flex;
        flex-direction: column;
      "
      ref="sidebarScrollArea"
    >
      <!-- Navigation Links scroll area -->
      <div style="flex: 1; overflow-y: auto; padding-bottom: 20px">
        <ul class="nav" style="margin-top: 10px">
          <slot name="links">
            <sidebar-item
              v-for="(link, index) in sidebarLinks"
              :key="link.name + index"
              :link="link"
            >
              <sidebar-item
                v-for="(subLink, index) in link.children"
                :key="subLink.name + index"
              >
              </sidebar-item>
            </sidebar-item>
          </slot>
          <slot></slot>
        </ul>
      </div>

      <!-- VIP Support Footer Card -->
      <div
        class="vip-support-container"
        :class="{ 'is-minimized': isMinimized }"
      >
        <div
          v-if="isMinimized"
          class="vip-support-minimized"
          @click="openWhatsApp"
          title="VIP Support - Chat with Marrissa"
        >
          <span class="pulsing-dot-minimized"></span>
          <span class="support-icon" v-html="ICONS.messageSquare"></span>
        </div>
        <div v-else class="vip-support-card">
          <div class="support-header">
            <h4>VIP Support</h4>
            <div class="status-indicator">
              <span class="pulsing-dot"></span>
              Active Now
            </div>
          </div>
          <button class="btn btn-chat" @click="openWhatsApp">
            Chat with Marrissa
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ICONS } from '@/common/colored-icons';

export default {
  name: 'sidebar',
  data() {
    return {
      ICONS,
      miniLogo:
        'https://imgix.cosmicjs.com/3acdf350-9b87-11ee-b34c-99d1d89e42eb-tp-logo-40pt.png',
    };
  },
  props: {
    title: {
      type: String,
      default: 'Cabo Party',
      description: 'Sidebar title',
    },
    shortTitle: {
      type: String,
      default: 'CP',
      description: 'Sidebar short title',
    },
    logo: {
      type: String,
      default:
        'https://imgix.cosmicjs.com/af58fcd0-2400-11f0-a845-63684478fa01-cabo-logo.png',
      description: 'Sidebar logo',
    },
    backgroundColor: {
      type: String,
      default: 'gray',
      description: 'Sidebar background color (gray)',
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
      description:
        "List of sidebar links as an array if you don't want to use components for these.",
    },
    autoClose: {
      type: Boolean,
      default: true,
      description:
        'Whether sidebar should autoclose on mobile when clicking an item',
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  computed: {
    isMinimized() {
      return this.$sidebar && this.$sidebar.isMinimized;
    },
  },
  methods: {
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    openWhatsApp() {
      const message =
        'Hi Marrissa! I would like to get VIP bookings and concierge assistance in Los Cabos.';
      const encodedMsg = encodeURIComponent(message);

      if (this.$trackEventLead) {
        this.$trackEventLead('sidebar-vip-support-cabo', 'reservations');
      }

      window.open(`https://wa.me/524421177251?text=${encodedMsg}`, '_blank');
    },
  },
  mounted() {
    if (typeof document !== 'undefined' && this.$sidebar) {
      this.$sidebar.isMinimized =
        document.body.classList.contains('sidebar-mini');
    }
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
};
</script>

<style scoped lang="scss">
@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}

.vip-support-container {
  margin-top: auto;
  padding: 15px;
  background: transparent;

  &.is-minimized {
    padding: 10px;
    width: 44px;
    height: 44px;
    margin: 10px auto;
  }
}

.vip-support-card {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  padding: 12px 14px;
  backdrop-filter: blur(10px);
}

.support-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;

  h4 {
    font-family: 'Poppins', sans-serif;
    font-size: 0.8rem;
    font-weight: 700;
    margin: 0;
    color: #fff;
  }
}

.status-indicator {
  display: flex;
  align-items: center;
  font-size: 0.65rem;
  color: #888;
  font-weight: 600;
}

.pulsing-dot {
  width: 6px;
  height: 6px;
  background-color: #2dce89;
  border-radius: 50%;
  margin-right: 6px;
  animation: pulse 1.8s infinite;
}

.pulsing-dot-minimized {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 6px;
  height: 6px;
  background-color: #2dce89;
  border-radius: 50%;
  animation: pulse 1.8s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(45, 206, 137, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 5px rgba(45, 206, 137, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(45, 206, 137, 0);
  }
}

.btn-chat {
  width: 100%;
  background: linear-gradient(90deg, #dfb784 0%, #db9454 100%);
  border: none;
  color: #111;
  font-family: 'Poppins', sans-serif;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 8px 12px;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #dfb784;
    transform: translateY(-1px);
    box-shadow: 0 4px 10px rgba(223, 183, 132, 0.3);
  }
}

.vip-support-minimized {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(52, 199, 89, 0.15);
    border-color: rgba(52, 199, 89, 0.4);
    color: #34c759;
  }

  .support-icon ::v-deep svg {
    width: 18px;
    height: 18px;
  }
}
</style>
